<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          background-color="white"
          placeholder="ค้นหา"
          v-model="search"
          clearable
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <template v-for="product in filterProducts">
        <v-col cols="12" sm="6" :key="`product_${product.id}`">
          <v-card outlined>
            <v-card-text>
              <v-chip class="mb-2" :color="product.status ? 'success' : 'error'" x-small>{{
                product.status ? "เปิดใช้งาน" : "ปิดใช้งาน"
              }}</v-chip>
              <v-row>
                <v-col cols="3" sm="2" shrink>
                  <v-img
                    :src="product.photourl[0]"
                    :lazy-src="product.photourl[0]"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-col>
                <v-col>
                  <div class=" mb-2">
                    {{ product.name }}
                    <div class="primary--text">
                      <span class="red--text"
                        >{{ product.discountpricerange | decimalFormat }} บาท</span
                      >
                      / {{ product.pricerange | decimalFormat }} บาท
                    </div>
                  </div>
                  <v-textarea
                    dense
                    hide-details=""
                    filled
                    rows="1"
                    onclick="this.select()"
                    readonly
                    :value="product.sharelink"
                  >
                    <template v-slot:append-outer>
                      <v-btn
                        small
                        depressed
                        color="primary"
                        v-clipboard:copy="product.sharelink"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >
                        <v-icon small>
                          mdi-content-copy
                        </v-icon>
                        <div class="hidden-xs-only ml-2">
                          คัดลอก
                        </div>
                      </v-btn>
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider />
            <template v-if="product.showStock">
              <v-simple-table class="grey lighten-4">
                <template v-slot:default>
                  <thead>
                    <tr class="white">
                      <th class="text-left">
                        ชื่อ
                      </th>
                      <th class="text-center">
                        จำนวน
                      </th>
                      <th class="text-center">
                        ราคา
                      </th>
                      <th class="text-center">
                        ราคาลด
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="stock in product.productstock">
                      <tr :key="`stock_${stock[0]}`">
                        <td>{{ stock[1] }}</td>
                        <td class="text-center">{{ stock[2] }}</td>
                        <td class="text-center">{{ stock[3] | decimalFormat }} บาท</td>
                        <td class="text-center">{{ stock[4] | decimalFormat }} บาท</td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
              <v-divider />
            </template>
            <v-btn block x-small text tile @click="product.showStock = !product.showStock">
              <v-icon small>{{
                !product.showStock ? "mdi-chevron-down" : "mdi-chevron-up"
              }}</v-icon>
              <div class="caption">ดูสต๊อคสินค้า</div>
            </v-btn>
          </v-card>
        </v-col>
      </template>
    </v-row>

    <v-snackbar v-model="snackbar" :color="type">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-pagination
      class="mt-3"
      color="primary"
      v-model="pageNumber"
      :length="pageCount"
    ></v-pagination>
  </v-container>
</template>

<script>
import axios from "axios";
import numeral from "numeral";
export default {
  data() {
    return {
      search: "",
      showStock: false,
      products: [],
      pageNumber: 1,
      productCount: 0,
      size: 20,
      snackbar: false,
      text: "",
      type: "success",
    };
  },
  mounted() {
    this.getProduct();
  },
  computed: {
    filterProducts() {
      const filteredProducted = this.onFilterProducts();

      const start = (this.pageNumber - 1) * this.size;
      const end = start + this.size;

      return filteredProducted.slice(start, end);
    },
    pageCount: function() {
      let l = this.filterProducts.length;
      let s = this.size;
      return Math.ceil(l / s);
    },
  },
  methods: {
    getPriceRange(price, stock) {
      var min = 0;
      var max = 0;

      if (stock.length <= 0) {
        min = price;
        max = price;
      } else {
        for (let index = 0; index < stock.length; index++) {
          if (index == 0) {
            min = stock[index][3];
            max = stock[index][3];
          } else {
            if (stock[index][3] > max) {
              max = stock[index][3];
            }
            if (stock[index][3] < min) {
              min = stock[index][3];
            }
          }
        }
      }

      if (min == max) {
        return numeral(min).format("0,0.00");
      } else {
        return numeral(min).format("0,0.00") + " - " + numeral(max).format("0,0.00");
      }
    },
    getDiscountPriceRange: function(discountprice, stock) {
      var min = 0;
      var max = 0;

      if (stock.length <= 0) {
        min = discountprice;
        max = discountprice;
      } else {
        for (let index = 0; index < stock.length; index++) {
          if (index == 0) {
            min = stock[index][4];
            max = stock[index][4];
          } else {
            if (stock[index][4] > max) {
              max = stock[index][4];
            }
            if (stock[index][4] < min) {
              min = stock[index][4];
            }
          }
        }
      }

      if (min == max) {
        return numeral(min).format("0,0.00");
      } else {
        return numeral(min).format("0,0.00") + " - " + numeral(max).format("0,0.00");
      }
    },
    onFilterProducts() {
      var productlist = this.products;

      if (this.search != "" && productlist) {
        productlist = productlist.filter((product) => {
          return product.name.toLowerCase().includes(this.search.toLowerCase());
        });
      }

      return productlist;
    },
    onCopy() {
      this.text = "Success";
      this.type = "success";
      this.snackbar = true;
    },
    onError() {
      this.text = "Fail";
      this.type = "error";
      this.snackbar = true;
    },
    async getProduct() {
      var response = await axios.get(
        `${this.$store.state.serverUrl}chillpainai_products`,

        {
          params: { pageid: this.$store.state.pageid, userid: this.$store.state.user.user.userid },
          headers: {
            AUTHORIZATION: "BEARER xxx xxx",
          },
        }
      );
      if (
        response.status == 200 &&
        response.data.responsecode == 200 &&
        response.data.productlist
      ) {
        this.products = response.data.productlist.map((product) => {
          var stock = product.productstock.map((stock) => {
            var price = 0;
            var discount = 0;

            if (stock[3] == null && stock[4] == null) {
              price = parseFloat(product.price);
              discount = parseFloat(product.discountprice);
            } else {
              if (stock[3] == null) {
                price = parseFloat(product.price);
              } else {
                price = parseFloat(stock[3]);
              }

              if (stock[4] == null) {
                discount = stock[3];
              } else {
                discount = parseFloat(stock[4]);
              }
            }

            stock[3] = price;

            stock[4] = discount;

            return stock;
          });

          return {
            ...product,
            photourl: product.photourl != null ? product.photourl.split(";;") : [],
            sharelink: `https://m.me/${this.$store.state.pageid}?ref=askproduct_${product.id}|influ=${this.$store.state.user.user.userid}`,
            productstock: stock,
            pricerange: this.getPriceRange(product.price, stock),
            discountpricerange: this.getDiscountPriceRange(product.discountprice, stock),
            showStock: false,
          };
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
